export default __webpack_public_path__ + "static/bg-zappi-110efe336645c40bd7d0f6c5df337bc7.jpg";